/** @jsx jsx */

import { Fragment } from 'react';

import { jsx } from '@emotion/core';

import MonthlyUsageResetDate from 'app/common/components/MonthlyUsageResetDate';
import UsageDetailsBar from 'app/common/components/UsageDetailsBar';
import { MenuSection } from 'app/common/components/Menu';

const monthlyUsageSectionCss = {
  fontSize: '1.2rem',
};

const usageDetailsBarCss = {
  '&:not(:only-child)': {
    marginBottom: '0.8em',
  },
};

const AccountUsage = ({
  numTasks,
  numFreeTasksMax,
  numTasksMax,
  numLiveZaps,
  numLiveZapsMax,
  resetDate,
  isPlanMetered,
  isTrialing,
}) => {
  const hasUsedExtraTasks = isPlanMetered && numTasks > numFreeTasksMax;
  const extraTasks = hasUsedExtraTasks && (
    <UsageDetailsBar
      css={usageDetailsBarCss}
      label="Extra Tasks"
      max={numTasksMax - numFreeTasksMax}
      tooltipContent="Once you’ve reached your Included Tasks limit, any Extra Tasks your team uses are added to your monthly bill."
      value={numTasks - numFreeTasksMax}
    />
  );

  return (
    <MenuSection css={monthlyUsageSectionCss}>
      <UsageDetailsBar
        css={usageDetailsBarCss}
        label={isPlanMetered ? 'Included Tasks' : 'Tasks'}
        max={isPlanMetered ? numFreeTasksMax : numTasksMax}
        tooltipContent="Number of Tasks included in your plan for this billing period."
        value={isPlanMetered ? Math.min(numTasks, numFreeTasksMax) : numTasks}
      />
      {extraTasks}
      {!isTrialing && (
        <Fragment>
          <UsageDetailsBar
            css={usageDetailsBarCss}
            label="Zaps"
            max={numLiveZapsMax}
            value={numLiveZaps}
          />
          <MonthlyUsageResetDate
            endDate={resetDate}
            label="Monthly usage resets on"
          />
        </Fragment>
      )}
    </MenuSection>
  );
};

export default AccountUsage;
